/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Tier_AffiliateInputs */



/**
* | output |
* | --- |
* | "Affiliate" |
*
* @param {Partner_Admin_Tier_AffiliateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_tier_affiliate = /** @type {((inputs?: Partner_Admin_Tier_AffiliateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Tier_AffiliateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Affiliate")
	return /** @type {LocalizedString} */ ("Affiliate")
});